type TLayoutStyle = {
  id: string;
  width: string;
  height: string;
};

const Layouts: Record<string, TLayoutStyle> = {
  leaderboard: {
    id: 'leaderboard',
    width: '728px',
    height: '90px',
  },
  'medium-rectangle': {
    id: 'medium-rectangle',
    width: '300px',
    height: '250px',
  },
  'wide-skyscraper': {
    id: 'wide-skyscraper',
    width: '160px',
    height: '600px',
  },
};

function getLayoutStyle({ layoutId }): Partial<CSSStyleDeclaration> {
  const layoutObj = Layouts[layoutId];
  if (!layoutObj) {
    return {};
  }
  const { width, height } = layoutObj;
  return { width, height };
}

export { getLayoutStyle };
